import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, CreditCardIcon, DownloadIcon, LockIcon, ZapIcon } from 'lucide-react';
import { BRAND_NAME, CTAButton } from './Shared';
import { Blossom, CreamJar, DropperBottle, Lavender, Sprig } from './Decor';
const productImage = 'https://cdn.magicpatterns.com/uploads/pQXPuehcHEKjA3HHHtVH7c/ChatGPT_Image_27_ago_2026,_19_39_20.png';
const stats = [{
  icon: DownloadIcon,
  text: 'Listo para imprimir o usar en tablet'
}, {
  icon: LockIcon,
  text: 'Pago 100% seguro con Mercado Pago'
}, {
  icon: ZapIcon,
  text: 'Acceso inmediato en 5 minutos'
}];
export function Hero() {
  return <header className="relative overflow-hidden bg-brand-sageDeep pb-6 pt-4 text-brand-cream md:pb-20 md:pt-16" data-id="element-130" data-mp="sde12olejdtn">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden" data-id="element-131" data-mp="nekqb3xi20x6">
        <Sprig className="animate-float-slow absolute -left-6 top-6 h-72 w-44 text-brand-sage/35 md:h-96 md:w-56" data-id="element-132" data-mp="3cz5weevm861x" />
        <Sprig className="animate-float-soft absolute -right-8 top-24 h-72 w-44 -scale-x-100 text-brand-sage/30 md:h-[26rem] md:w-56" data-id="element-133" data-mp="3j8sezzr63hpb" />
        <Lavender className="animate-float-soft absolute left-[16%] top-[6%] hidden h-64 w-16 text-brand-lavender/35 lg:block" data-id="element-134" data-mp="3o6aphuku24zf" />
        <Lavender className="animate-float-slow absolute right-[18%] top-[10%] hidden h-56 w-14 text-brand-lavender/30 lg:block" data-id="element-135" data-mp="39cflp2zjb5v3" />
        <Blossom className="absolute left-[10%] top-[54%] h-16 w-16 text-brand-rose/40 md:h-24 md:w-24" data-id="element-136" data-mp="30ib0az366mmy" />
        <Blossom className="absolute right-[13%] top-[20%] h-12 w-12 text-brand-gold/45 md:h-16 md:w-16" data-id="element-137" data-mp="3599i633t3ssb" />
        <DropperBottle className="animate-float-soft absolute bottom-8 left-[5%] hidden h-40 w-20 text-brand-goldLight/30 lg:block" data-id="element-138" data-mp="2qkd9q4xu8dr6" />
        <DropperBottle className="animate-float-slow absolute bottom-24 right-[6%] hidden h-32 w-16 text-brand-goldLight/25 lg:block" data-id="element-139" data-mp="2vjg5szvub9n0" />
        <CreamJar className="animate-float-soft absolute bottom-6 right-[14%] hidden h-24 w-24 text-brand-sageMist/25 lg:block" data-id="element-140" data-mp="2lkqzm4db3dml" />
        <div className="absolute -top-24 left-1/2 h-72 w-[36rem] -translate-x-1/2 rounded-full bg-brand-sageMid/40 blur-[120px]" data-id="element-141" data-mp="s2b9g2qj4r79" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8" data-id="element-142" data-mp="na0ap37izbga">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-143" data-mp="icrp0sn64paa">
          <div className="mb-2.5 inline-flex items-center gap-2 rounded-full border border-brand-gold/50 bg-white/10 px-3 py-1 backdrop-blur-sm md:mb-4 md:px-4 md:py-1.5" data-id="element-144" data-mp="1b04cr652f356">
            <span className="text-[10px] md:text-sm" data-id="element-145" data-mp="111om149y9vw7">🌿</span>
            <span className="font-title text-[9px] font-bold tracking-[.18em] text-brand-goldLight md:text-xs" data-id="element-146" data-mp="x14npxdn4m8h">
              {BRAND_NAME}™
            </span>
          </div>

          <div className="mx-auto max-w-5xl" data-id="element-147" data-mp="3lqudvm65c340">
            <h1 className="neon-title font-serif text-[27px] font-bold leading-[1.06] tracking-tight md:text-[clamp(2.8rem,7vw,5.4rem)] md:leading-[1.02] md:tracking-[-0.035em]" data-id="element-148" data-mp="3hr3sxz3awh7e">
              <span className="block" data-id="element-149" data-mp="21amw19r97smc">COSMÉTICA</span>
              <span className="neon-accent block" data-id="element-150" data-mp="21bfs9gsl6zq8">NATURAL</span>
            </h1>
            <div className="neon-underline mx-auto mt-3 w-32 md:mt-5 md:w-72" aria-hidden="true" data-id="element-151" data-mp="268y3jdu2tr1e" />
            <p className="mx-auto mt-3 max-w-3xl font-display text-[13px] font-medium leading-snug text-brand-goldLight md:mt-6 md:text-2xl" style={{
            fontSize: "32px",
            fontWeight: "800"
          }} data-id="element-152" data-mp="2b1r8a1pjozdh">
              Genera ingresos reales como un profesional
            </p>
            
          </div>

          <div className="mx-auto mt-3 flex w-full max-w-3xl justify-center md:mt-10" data-id="element-153" data-mp="2p1jylvx5tdkx">
            <motion.img src={productImage} alt="Pack Cosmética Natural: los 3 tomos principales, los 6 bonus y las fichas de fórmulas" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.3,
            ease: [0.23, 1, 0.32, 1]
          }} className="h-auto w-[80%] max-w-[290px] drop-shadow-2xl sm:w-[76%] sm:max-w-[460px] md:w-full md:max-w-[680px]" draggable={false} fetchPriority="high" data-id="element-154" data-mp="2tztu67msqg72" />
          </div>

          <div className="mx-auto mt-3 max-w-3xl space-y-2 md:mt-6 md:space-y-3" data-id="element-155" data-mp="e91vgguxa1c2">
            <div className="leaf-rule mx-auto max-w-xs" aria-hidden="true" data-id="element-156" data-mp="9bs7l5n6lxqc" />
            <p className="mx-auto hidden max-w-2xl font-serif text-[15px] font-medium leading-snug text-brand-cream/90 md:block md:text-xl md:leading-normal" data-id="element-157" data-mp="3hpqyvtz7kuxi">
              🌸 300 páginas de recetarios, alquimia vibracional, estrategia de precios y branding magnético. Todo lo
              que necesitás para transformar tu cocina en un negocio rentable desde casa.
            </p>
            <p className="mx-auto max-w-xs font-serif text-[12px] font-medium leading-snug text-brand-cream/90 md:hidden" data-id="element-158" data-mp="2yzj3jy1r38rv">
              🌸 300 páginas: recetarios, precios y branding magnético.
            </p>
            <CTAButton variant="gold" className="cta-shimmer relative overflow-hidden px-6 py-2.5 text-[13px] md:mt-3 md:px-10 md:py-5 md:text-xl" data-id="element-159" data-mp="19i5dsgkmn4g3">
              <span className="relative z-10" data-id="element-160" data-mp="1eaou3lap8dol">VER PACK →</span>
            </CTAButton>
          </div>

          <div className="mx-auto mt-3 grid max-w-3xl grid-cols-3 gap-2 rounded-2xl border border-white/15 bg-white/5 p-3 backdrop-blur-sm md:mt-10 md:gap-3 md:p-5" data-id="element-161" data-mp="zmaox3pt8d4v">
            {stats.map(stat => {
            const Icon = stat.icon;
            return <div key={stat.text} className="flex flex-col items-center gap-1 text-center md:gap-2" data-id="element-162" data-mp="1x8ro6ei3t0t9">
                  <Icon className="h-4 w-4 text-brand-gold md:h-6 md:w-6" data-id="element-163" data-mp="1j9053zcqcu8e" />
                  <span className="text-[9px] leading-tight text-brand-cream/80 md:text-sm md:leading-snug" data-id="element-164" data-mp="1na21m8f9is6o">
                    {stat.text}
                  </span>
                </div>;
          })}
          </div>

          <div className="mt-3 flex flex-wrap justify-center gap-1.5 text-[9px] font-semibold md:mt-6 md:gap-2 md:text-sm" data-id="element-165" data-mp="bves1s6hyrqr">
            <span className="rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-brand-cream/85" data-id="element-166" data-mp="2egitaak18gf3">
              <BookOpenIcon className="mr-1.5 inline h-3.5 w-3.5 text-brand-gold" data-id="element-167" data-mp="29jsgpx7fs2yf" />
              100% PDF
            </span>
            <span className="rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-brand-cream/85" data-id="element-168" data-mp="24po3wxbhp0pf">
              <CheckCircle2Icon className="mr-1.5 inline h-3.5 w-3.5 text-brand-gold" data-id="element-169" data-mp="1zqtmnzt67k7f" />
              Garantía 7 días
            </span>
            <span className="rounded-full border border-white/20 bg-white/5 px-3 py-1.5 text-brand-cream/85" data-id="element-170" data-mp="1qrq3ywxx16tg">
              <CreditCardIcon className="mr-1.5 inline h-3.5 w-3.5 text-brand-gold" data-id="element-171" data-mp="1ltxzz4jzxu8w" />
              Mercado Pago
            </span>
            <span className="rounded-full border border-brand-gold/50 bg-brand-gold/15 px-3 py-1.5 text-brand-goldLight" data-id="element-172" data-mp="1gvmqww1iznrq">
              🌿 El kit argentino más completo
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}